export const packageName = 'jiraServicedeskRequestTypeSecurity';
export const teamName = 'jsm-request-intake';

export const REQUEST_TYPE_SECURITY_ONBOARDING_USER_PROPERTY_KEY =
	'request-type-security-onboarding-seen-status';

export const REQUEST_TYPE_SECURITY_ONBOARDING_V2_USER_PROPERTY_KEY =
	'request-type-security-onboarding-v2-seen-status';

export const REQUEST_TYPE_ISSUE_SECURITY_CHANGEBOARDING_USER_PROPERTY_KEY =
	'request-type-issue-security-changeboarding-seen-status';
